import React from 'react'
import styled from 'styled-components'
import { Col, Row } from 'react-flexbox-grid'
import { currency, generateMediaUrl } from 'utils'

import AditionalServices from 'components/AditionalServices'
import { Marginer } from 'components/Util'
import Gas from 'components/Svg/ic-gas.svg'
import Electricity from 'components/Svg/ic-eletricidade.svg'
import Order from 'components/Svg/ic-contrato-faturacao.svg'

const MonthlyInvoice = (props) => {
  return (
    <div>
      <Marginer>
        <Marginer top='12' right='0' bottom='0' left='0'>
          <Row>
            <Col xs={6}>
              <Entity
                src={
                  props.tariffInfo.entity &&
                  generateMediaUrl(props.tariffInfo.entity.hi_res_logo)
                }
                alt={
                  props.tariffInfo.entity && props.tariffInfo.entity.designation
                }
              />
            </Col>
            <Col xs={6}>
              <BigTitle>Fatura Mensal</BigTitle>
              <Value>
                {currency(props.tariff && props.tariff.annualBilling / 12)}
                <Unit>€</Unit>
              </Value>
            </Col>
          </Row>
        </Marginer>
      </Marginer>
      <Marginer top='37' right='0' bottom='0' left='0'>
        <Row>
          {props.tariff.electricityPriceList && (
            <Col xs={6}>
              <Title style={{ color: '#FF8E2A', marginBottom: 10 }}>
                <EletricityIcon src={Electricity} />
                Eletricidade
              </Title>
              <Row>
                <Col xs={6}>
                  <Label>Termo Potência</Label>
                  <Value>
                    {currency(props.tariff.electricityFixedTerm / 12)}€
                  </Value>
                </Col>
                <Col xs={6}>
                  <Label>Energia</Label>
                  <Value>
                    {currency(props.tariff.electricityEnergy / 12)}€
                  </Value>
                </Col>
              </Row>
            </Col>
          )}
          {props.tariff.gasPriceList && (
            <Col xs={6}>
              <Title
                style={{ color: '#00BDED', marginBottom: 10, marginTop: 5 }}>
                <GasIcon src={Gas} />
                Gás Natural
              </Title>
              <Row>
                <Col xs={6}>
                  <Label>Termo Fixo</Label>
                  <Value>{currency(props.tariff.gasFixedTerm / 12)}€</Value>
                </Col>
                <Col xs={6}>
                  <Label>Energia</Label>
                  <Value>{currency(props.tariff.gasEnergy / 12)}€</Value>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Marginer>
      <Marginer top='48' right='0' left='0' bottom='0'>
        <Title>
          <OrderIcon src={Order} />
          Impostos
        </Title>
        <Marginer top='12' right='0' bottom='0' left='0'>
          <Row>
            <Col xs={6}>
              <Label>Total</Label>
              <Value>{currency(props.tariff.annualTaxes / 12)}€</Value>
            </Col>
            <Col xs={6} style={{ marginTop: -25 }}>
              <AditionalServices
                style={{ margin: 0 }}
                list={props.tariffInfo.additional_services}
              />
            </Col>
          </Row>
        </Marginer>
      </Marginer>
    </div>
  )
}

const Title = styled.span`
  display: block;
  color: #3e3e3e;
  font-family: Nunito;
  font-size: 17px;
  font-weight: bold;
  line-height: 14px;
`

const BigTitle = styled.span`
  display: block;
  color: #3e3e3e;
  font-family: Nunito;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
`

const GasIcon = styled.img`
  max-width: 5%;
  margin-right: 5px;
`

const EletricityIcon = styled.img`
  max-width: 5%;
  margin-right: 5px;
`

const OrderIcon = styled.img`
  max-width: 5%;
  margin-right: 6px;
`

const Entity = styled.img`
  max-height: 80%;
  max-width: 80%;
  display: block;
`

const Label = styled.span`
  color: #9c9c9c;
  font-family: Nunito;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
`

const Unit = styled.span`
  font-weight: normal;
`

const Value = styled.div`
  color: #676767;
  font-family: Nunito;
  font-size: 18px;
  font-weight: bold;
  line-height: 18px;
`

export default MonthlyInvoice



// WEBPACK FOOTER //
// ./src/components/MonthlyInvoice/index.js